export const BASE_URL = "https://xlit-api.ai4bharat.org/";
